<script lang="ts">
	import {uqn} from './stores.js';
	// import Fraction from './functions/fractionClass';
	import check from './check_random/check';
	import Textfield, {Input, Textarea} from '@smui/textfield';
	import Button, {Label, Icon} from '@smui/button';
	import Dialog, {Title, Content, Actions} from '@smui/dialog';
	import Slider from '@smui/slider';
	import FormField from '@smui/form-field';
	import Katex from './Katex.svelte';
	import Radio from '@smui/radio';
	import { onMount } from 'svelte';
	import getRandomInt from './functions/getRandomInt';

	let uqnInput: number;
	$: uqnInput = $uqn;
	let simpleDialog;

	let changeDummy, changeDummy2;
	// initialize
	let type = $uqn.toString()[0];
	let digits = Number($uqn.toString()[1]);
	let compare = Number($uqn.toString()[2]);
	let choices = Number($uqn.toString()[3]);
	let digitsKatex:string, compareKatex:string, choicesKatex:string, compareMax: number;

	$: changeDummy = updateFromUQN($uqn);
	$: changeDummy2 = updateFromSliders(type,digits,compare,choices)

/* 	onMount(() => {
		type = Number($uqn.toString()[0]);
	}); */
	
	function updateFromUQN(u:number){
		type = u.toString()[0];
		digits = Number(u.toString()[1]);
		compare = Number(u.toString()[2]);
		choices = Number(u.toString()[3]);
		if (type=="1"){
			compareMax = digits-1;
		} else{
			compareMax = choices-1;
		}
	}

	function updateFromSliders(t:string,d:number,com:number,ch:number){
		type = t;
		if (t=="1"){
			if (com>=d){
				com = getRandomInt(2,d-1)
			}
			compareMax = d-1;
			ch = 0;
		} else{
			if (ch<d){
				ch = getRandomInt(d+1,9)
			}
			if (com>=ch){
				com = getRandomInt(2,d-1);
			}
			compareMax = ch-1;
		}
		digitsKatex = "n="+d.toString();
		choicesKatex = "m="+ch.toString();
		compareKatex = "x="+ (com*Math.pow(10,digits-1)).toString();
		digits = d;
		compare = com;
		choices = ch;
		uqnInput = Number(t)*1000+d*100+com*10+ch;
		uqn.set(uqnInput);
	}

	function uqnClick(){
		if (check(uqnInput)){
			uqn.set(uqnInput);
		} else{
			simpleDialog.open();
		}
	}	
</script>

<h2>Options</h2>
<hr>
<h3>UQN</h3>
<p>
	Retrieve a question by keying in a 4-digit UQN:
</p>
<Textfield class="shaped-outlined" variant="outlined" bind:value={uqnInput} label="UQN" type="number"/>
<Button on:click={uqnClick} variant="unelevated" class="button-shaped-round">
	<!-- <Icon class="material-icons">favorite</Icon> -->
	<Label>Generate question</Label>
</Button>
<hr>
<h3>
	Question construction tools
</h3>
<p> 
	In this question, we will be asked to create an <Katex math="n"/>-digit number from the digits
	<Katex math="1,2,\ldots,m"/>.<br>
	In some parts we will also require that the number is more than <Katex math="x"/>.
</p>
<div>
	<p>First choose the general type of question:</p>
	<FormField>
		<Radio bind:group={type} value=1/>
		<span slot="label"><Katex math="m=n"/>, repetitions not allowed</span>
	</FormField>
	<FormField>
		<Radio bind:group={type} value=2/>
		<span slot="label"><Katex math="m>n"/>, repetitions not allowed</span>
	</FormField>
	<FormField>
		<Radio bind:group={type} value=3/>
		<span slot="label"><Katex math="m>n"/>, repetitions allowed</span>
	</FormField>
</div>
<p>
	Use the sliders belows to choose different options to craft your own unique question.
</p>
<hr>
<div>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={digits} min={4} max={6} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={digitsKatex}/></span>
	</FormField>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={compare} min={2} max={compareMax} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={compareKatex}/></span>
	</FormField>
	{#if type>1}
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={choices} min={digits+1} max={9} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={choicesKatex}/></span>
	</FormField>
	{/if}
</div>
<!-- <FormField align="end" style="display: flex;">
	<Slider bind:value={$a} min={2} max={k} step={1} discrete displayMarkers />
	<span slot="label" style="padding-right: 12px; width: max-content; display: block;">Amount of Wonder</span>
</FormField> -->


<Dialog bind:this={simpleDialog}>
	<!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
	<Title>Invalid UQN</Title>
	<Content>
		You have keyed an invalid UQN. Please try again.
	</Content>
	<Actions>
		<Button>
			<Label>OK</Label>
		</Button>
	</Actions>
</Dialog>
<hr>